// @flow
import $ from 'jquery';
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import DateRangePicker from '../../common/DateRangePicker';
import { color } from '../../../styles/theme';
import dayjs from 'dayjs';
import SearchAddressForm from '../../common/SearchAddressForm';

export default class FormView extends JQueryView {
  holderType: string;
  agentHolderType: string | null;
  agentType: string | null;
  isOverseas: boolean;
  isAgentOverseas: boolean | null;
  hasChangedResidence: boolean;
  establishAt: string;
  formDisabled: boolean;
  disabledHolderType: boolean;
  agentRadioSelectors: Array<string>;
  agentColumns: Array<string>;
  documentMailingAddressColumns: Array<string>;
  searchAddress: Object;

  constructor(
    holderType: string,
    agentHolderType: string | null,
    agentType: string | null,
    isOverseas: boolean,
    isAgentOverseas: boolean | null,
    establishAt: string,
    formDisabled: boolean,
    disabledHolderType: boolean,
  ) {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });

    const agentRadioSelectors = [
      'holder_type_user',
      'holder_type_company',
      'agent_type_permanent',
      'agent_type_legal',
      'overseas_false',
      'overseas_true',
      'convocation_20',
      'convocation_0',
    ];

    const agentColumns = [
      'last_name',
      'first_name',
      'email',
      'zip_code',
      'prefecture',
      'city',
      'address',
      'address_detail',
    ];

    const documentMailingAddressColumns = [
      'zip_code',
      'prefecture',
      'city',
      'address',
      'address_detail',
    ];

    this.holderType = holderType;
    this.agentHolderType = agentHolderType;
    this.agentType = agentType;
    this.isOverseas = isOverseas;
    this.isAgentOverseas = isAgentOverseas ? isAgentOverseas : false;
    this.hasChangedResidence = false;
    this.establishAt = establishAt;
    this.formDisabled = formDisabled;
    this.disabledHolderType = disabledHolderType;
    this.agentRadioSelectors = agentRadioSelectors;
    this.agentColumns = agentColumns;
    this.documentMailingAddressColumns = documentMailingAddressColumns;
    this.render();
    this.renderPersonalArea();
    this.renderAgentArea();
    this.renderMailingArea();
    this.renderAgentPersonalArea();
    this.renderAddressArea();
    this.renderAgentAddressArea();
    this.renderStaffArea();
    this.renderAlternativeArea();
    if (this.disabledHolderType) {
      this.renderDisabledHolderType();
    }
    if (this.formDisabled) {
      this.renderDisabled();
    }
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        minDate: this.establishAt,
        maxDate: dayjs().toDate(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '#registered_address_button' })
  onClickSearchAddressA() {
    this.searchAddress.prefix = '[registered_attributes]';
  }

  @on({ event: 'click', selector: '#agent_address_button' })
  onClickAgentSearchAddress() {
    this.searchAddress.prefix = '[agent_attributes]';
  }

  @on({ event: 'click', selector: '#document_mailing_address_button' })
  onClickMailingSearchAddress() {
    this.searchAddress.prefix = '[document_mailing_address_attributes]';
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    event.preventDefault();

    this.renderStaffArea();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderStaffArea();
    this.render();
  }

  @on({ event: 'click', selector: '.add_staff_fields' })
  onClickAddStaffFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.staffs-info').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );

    this.renderStaffArea();
    this.render();
  }

  @on({ event: 'click', selector: '#add_alternative_field' })
  onClickAddAlternativeField() {
    $('#add_alternative_btn').hide();
    $('#alternative_info_modal').modal('hide');
    $('#alternative_field').show();
  }

  @on({ event: 'click', selector: '#remove_alternative_field' })
  onClickRemoveAlternativeField() {
    $('input[name="stakeholder[stockholder_meeting_alternative_email]"]').val(
      '',
    );
    $('#add_alternative_btn').show();
    $('#alternative_field').hide();
  }

  renderAlternativeArea() {
    if (
      $(
        'input[name="stakeholder[stockholder_meeting_alternative_email]"]',
      ).val()?.length === 0
    ) {
      $('#alternative_field').hide();
    } else {
      $('#add_alternative_btn').hide();
      $('#alternative_field').show();
    }
  }

  renderAgentArea() {
    const isChecked = this.agentRadioSelectors.some(selector =>
      $(`#stakeholder_agent_attributes_${selector}`).prop('checked'),
    );
    const isValue = this.agentColumns.some(
      column =>
        $(`input[name="stakeholder[agent_attributes][${column}]"]`).val()
          ?.length !== 0,
    );

    if (isChecked || isValue) {
      $('#add_agent_btn').hide();
      $('#agent_field').show();
      $('#remove_agent_field').show();
    } else {
      $('#agent_field').hide();
    }
  }

  renderMailingArea() {
    const isValue = this.documentMailingAddressColumns.some(
      column =>
        $(
          `input[name="stakeholder[document_mailing_address_attributes][${column}]"]`,
        ).val()?.length !== 0,
    );

    if (isValue) {
      $('#add_mailing_btn').hide();
      $('#mailing_field').show();
    } else {
      $('#mailing_field').hide();
    }
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    // 編集時はdatepickerは存在しない
    if (
      $('.date-field').length &&
      !$(event.target).closest('.date-field').length
    ) {
      $('.date-field').removeClass('focus');

      if (
        $('.date-field')
          .last()
          .val().length === 0
      ) {
        $('.date-field')
          .last()
          .removeClass('form-control-active');
      }
    }
  }

  renderStaffArea() {
    const maxStaffCount = 10;
    const staffInfoVisibleLength = $('.staff-info:visible').length;
    if (staffInfoVisibleLength >= maxStaffCount) {
      $('.add-staff').hide();
    } else {
      $('.add-staff').show();
    }

    let staffNumber = 1;
    $('.staffs-wrapper')
      .find('.staff-info')
      .each((index, item) => {
        if ($(item).is(':visible')) {
          const staffName = $(item).find('.label-staff-name');
          const iconInfo = $(item).find('.icon-info');

          staffName.text(`サブ担当者${staffNumber}`);
          if (staffNumber === 1) {
            iconInfo.show();
          } else {
            iconInfo.hide();
          }
          staffNumber += 1;
        }
      });
  }

  @on({ event: 'click', selector: '#add_agent_btn' })
  onClickAddAgentArea() {
    const selectors = [
      'holder_type_user',
      'agent_type_permanent',
      'convocation_20',
      'overseas_false',
    ];

    selectors.forEach(function(selector) {
      $(`#stakeholder_agent_attributes_${selector}`).prop('checked', true);
    });

    const agentHolderType = $(
      'input[name="stakeholder[agent_attributes][holder_type]"]',
    )
      .filter(':checked')
      .val();
    this.agentHolderType = agentHolderType;
    this.renderAgentPersonalArea();

    $('#add_agent_btn').hide();
    $('#remove_agent_field').show();
    $('#agent_field').show();
  }

  @on({ event: 'click', selector: '#remove_agent_field' })
  removeAgentArea() {
    this.agentRadioSelectors.forEach(function(selector) {
      $(`#stakeholder_agent_attributes_${selector}`).prop('checked', false);
    });

    this.agentColumns.forEach(function(column) {
      $(`input[name="stakeholder[agent_attributes][${column}]"]`).val('');
    });

    $('#add_agent_btn').show();
    $('#agent_field').hide();
    $('#remove_agent_field').hide();
  }

  @on({ event: 'click', selector: '#add_mailing_btn' })
  onClickAddMailingArea() {
    $('#add_mailing_btn').hide();
    $('#remove_mailing_field').show();
    $('#mailing_field').show();
  }

  @on({ event: 'click', selector: '#remove_mailing_field' })
  removeMailingArea() {
    this.documentMailingAddressColumns.forEach(function(column) {
      $(
        `input[name="stakeholder[document_mailing_address_attributes][${column}]"]`,
      ).val('');
    });

    $('#add_mailing_btn').show();
    $('#mailing_field').hide();
    $('#remove_mailing_field').hide();
  }

  render() {
    this.initDateRangePicker(this.$el);
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[holder_type]"]:radio',
  })
  onChangeHolderType() {
    const holderType = $('input[name="stakeholder[holder_type]"]')
      .filter(':checked')
      .val();
    this.holderType = holderType;
    this.renderPersonalArea();
  }

  renderPersonalArea() {
    if (this.holderType === 'User') {
      $('.stakeholder_company_name').hide();
      $('#stakeholder_company_name').val('');
      $('.stakeholder_representative_last_name').hide();
      $('#stakeholder_representative_last_name').val('');
      $('.stakeholder_representative_first_name').hide();
      $('#stakeholder_representative_first_name').val('');
      $('.stakeholder_last_name label').html('姓（漢字）');
      $('.stakeholder_first_name label').html('名（漢字）');
      $('.stakeholder_email label').html('メールアドレス');
      $('#stakeholder_last_name').addClass('rounded-top-left');
    } else if (this.holderType === 'Company') {
      $('.stakeholder_company_name').show();
      $('.stakeholder_representative_last_name').show();
      $('.stakeholder_representative_first_name').show();
      $('.stakeholder_last_name label').html('姓（担当者）');
      $('.stakeholder_first_name label').html('名（担当者）');
      $('.stakeholder_email label').html('担当者のメールアドレス');
      $('#stakeholder_last_name').removeClass('rounded-top-left');
    }
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[agent_attributes][holder_type]"]:radio',
  })
  onChangeAgentHolderType() {
    const agentHolderType = $(
      'input[name="stakeholder[agent_attributes][holder_type]"]',
    )
      .filter(':checked')
      .val();
    this.agentHolderType = agentHolderType;
    this.renderAgentPersonalArea();
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[agent_attributes][agent_type]"]:radio',
  })
  onChangeAgentType() {
    const agentType = $(
      'input[name="stakeholder[agent_attributes][agent_type]"]',
    )
      .filter(':checked')
      .val();
    this.agentType = agentType;
    this.renderAgentPersonalArea();
  }

  renderAgentPersonalArea() {
    if (this.agentHolderType === 'User') {
      $('.stakeholder_agent_company_name').hide();
      $('#stakeholder_agent_company_name').val('');
      $('.stakeholder_agent_representative_last_name').hide();
      $('#stakeholder_agent_representative_last_name').val('');
      $('.stakeholder_agent_representative_first_name').hide();
      $('#stakeholder_agent_representative_first_name').val('');
      $('.stakeholder_agent_last_name label').html('姓（漢字）');
      $('.stakeholder_agent_first_name label').html('名（漢字）');
      $('.stakeholder_agent_email label').html('メールアドレス');
      $('#stakeholder_agent_last_name').addClass('rounded-top-left');
    } else if (this.agentHolderType === 'Company') {
      $('.stakeholder_agent_company_name').show();
      $('.stakeholder_agent_representative_last_name').show();
      $('.stakeholder_agent_representative_first_name').show();
      $('.stakeholder_agent_last_name label').html('姓（担当者）');
      $('.stakeholder_agent_first_name label').html('名（担当者）');
      $('.stakeholder_agent_email label').html('担当者のメールアドレス');
      $('#stakeholder_agent_last_name').removeClass('rounded-top-left');
    }
    if (this.agentType == 'legal') {
      $('.stakeholder_agent_job_title').show();
    } else {
      $('.stakeholder_agent_job_title').hide();
      $('.stakeholder_agent_job_title').val('');
    }
  }

  @on({
    event: 'change',
    selector:
      'input[name="stakeholder[registered_attributes][overseas]"]:radio',
  })
  onChangeIsOverseas() {
    const isOverseas = $(
      'input[name="stakeholder[registered_attributes][overseas]"]',
    )
      .filter(':checked')
      .val();
    this.isOverseas = isOverseas === 'true';
    this.hasChangedResidence = true;
    this.renderAddressArea();
  }

  @on({
    event: 'change',
    selector: 'input[name="stakeholder[agent_attributes][overseas]"]:radio',
  })
  onChangeIsAgentOverseas() {
    const isAgentOverseas = $(
      'input[name="stakeholder[agent_attributes][overseas]"]',
    )
      .filter(':checked')
      .val();
    this.isAgentOverseas = isAgentOverseas === 'true';
    this.renderAgentAddressArea();
  }

  renderAddressArea() {
    if (this.isOverseas) {
      $(
        '#registered_address_button, .stakeholder_prefecture, .stakeholder_city, .stakeholder_address_detail',
      ).hide();
      $('#stakeholder_address').addClass('rounded-bottom');
    } else {
      $(
        '#registered_address_button, .stakeholder_prefecture, .stakeholder_city, .stakeholder_address_detail',
      ).show();
      $('#stakeholder_address').removeClass('rounded-bottom');
    }

    if (this.hasChangedResidence) {
      $(
        '#stakeholder_zip_code, #stakeholder_prefecture, #stakeholder_city, #stakeholder_address, #stakeholder_address_detail',
      ).val('');
      $(
        '#stakeholder_zip_code, #stakeholder_prefecture, #stakeholder_city, #stakeholder_address, #stakeholder_address_detail',
      ).removeClass('form-control-active');
    }
  }

  renderDisabledHolderType() {
    const holderType = $('input[name="stakeholder[holder_type]"]')
      .filter(':checked')
      .val();
    const unSelectedHolderType = $(
      'input[name="stakeholder[holder_type]"]:not(:checked)',
    );
    unSelectedHolderType.prop('disabled', true);
    this.holderType = holderType;
    $('#stakeholder_holder_type_user, #stakeholder_holder_type_company')
      .parent()
      .css({ 'background-color': color.smokeWhite });
  }

  renderDisabled() {
    this.renderDisabledHolderType();
    const unSelectedOverseas = $(
      'input[name="stakeholder[registered_attributes][overseas]"]:not(:checked)',
    );
    unSelectedOverseas.prop('disabled', true);
    if (this.holderType === 'User') {
      $('.stakeholder_company_name').hide();
      $('.stakeholder_representative_last_name').hide();
      $('.stakeholder_representative_first_name').hide();
    } else if (this.holderType === 'Company') {
      $('.stakeholder_company_name').show();
      $('.stakeholder_representative_last_name').show();
      $('.stakeholder_representative_first_name').show();
    }
    this.renderAddressArea();

    $(
      `#stakeholder_company_name, #stakeholder_last_name, #stakeholder_first_name,
      #stakeholder_representative_last_name, #stakeholder_representative_first_name,
       #stakeholder_email, #stakeholder_zip_code, #stakeholder_prefecture,
       #stakeholder_city,#stakeholder_address, #stakeholder_address_detail`,
    )
      .prop('disabled', true)
      .addClass('form-control-active');
    $('#stakeholder_overseas_true, #stakeholder_overseas_false')
      .parent()
      .css({ 'background-color': color.smokeWhite });
    $('#select_stakeholder_id').addClass('form-control-active');
    $('#registered_address_button').hide();
    $('#select_stakeholder_id').addClass('form-control-active');
  }

  renderAgentAddressArea() {
    if (this.isAgentOverseas) {
      $(
        '#agent_address_button, .stakeholder_agent_prefecture, .stakeholder_agent_city, .stakeholder_agent_address_detail',
      ).hide();
      $('#stakeholder_agent_address').addClass('rounded-bottom');
    } else {
      $(
        '#agent_address_button, .stakeholder_agent_prefecture, .stakeholder_agent_city, .stakeholder_agent_address_detail',
      ).show();
      $('#stakeholder_agent_address').removeClass('rounded-bottom');
    }
  }
}
